import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionRedoTlfChange, TlfContextProps } from "./interface";

/**
 * Moves forward through TLF undo history when later versions exist.
 *
 * @param state - Current TLF context state.
 * @param action - Redo action with an optional number of steps.
 * @returns Updated state after redoing available history entries.
 */
export const tlf_redoTlfChange = (
  state: TlfContextProps,
  action: ITlfActionRedoTlfChange,
): TlfContextProps => {
  const newState = { ...state };
  const newIx = Math.min(
    state.tlfDataVersions.length - 1,
    state.ixTlfDataVersion + (action.steps ?? 1),
  );

  if (newIx !== state.ixTlfDataVersion) {
    newState.ixTlfDataVersion = newIx;
    newState.tlfData = cloneDeep(state.tlfDataVersions[newIx]);
    checkChanged(newState);
    newState.forcePushToParent = true;
  }

  return newState;
};
